<template>
  <div id="main-wrapper">
    <div class="content-container profile-page deposit-live transactions-dep bonus-page">
      <div class="page-wrap">
        <div class="page-content clearfix">
          <div class="main-content f-left">
            <div class="title-holder">
              <h4>{{$t('referral_list.referrals_list')}}</h4>
            </div>
            <div class="content-holder">
              <p>{{$t('referral_list.list_of_referrals')}}</p>

              <div class="table-holder table-holder4">
                <table>
                  <thead>
                    <tr>
                      <th>{{$t('referral_list.s_no')}}</th>
                      <th>{{$t('referral_list.name')}}</th>
                      <th>{{$t('referral_list.email_id')}}</th>
                      <th>{{$t('referral_list.account_stage')}}</th>
                      <th>{{$t('referral_list.deposits')}}</th>
                      <th>{{$t('referral_list.volume_required')}}</th>
                      <th>{{$t('referral_list.traded_volume')}}</th>
                      <th>{{$t('referral_list.qualified')}}</th>
                    </tr>
                  </thead>
                  <!-- <tr>
                    <td>1</td>
                    <td>John</td>
                    <td>info@gmail.com</td>
                    <td>Funded</td>
                    <td>$500</td>
                    <td>10</td>
                    <td>3</td>
                    <td>Not Yet</td>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>John</td>
                    <td>info@gmail.com</td>
                    <td>Funded</td>
                    <td>$500</td>
                    <td>10</td>
                    <td>3</td>
                    <td>Yes</td>
                  </tr> -->
                  <tbody>
                    <tr>
                      <td colspan="8" class="t-center">{{$t('referral_list.no_data')}}</td>
                    </tr>
                </tbody>
                </table>
              </div>
              <div class="">
                <p>{{$t('referral_list.payment_of_referral_bonus')}}</p>
                <br>
                <p>{{$t('referral_list.referral_bonus_paid_in_aaafx_wallet')}}</p>
                <br>
                <p>{{$t('referral_list.read_all_terms_conditions')}} <a href="#">{{$t('referral_list.here')}}</a></p>
                <p>{{$t('referral_list.contact_us')}} <a href="mailto:customercare@aaafx-international.com">{{$t('referral_list.customer_care')}}</a></p>
                <br>
                <p> <strong>{{$t('referral_list.definitions')}}</strong></p>
                <p> {{$t('referral_list.meaning_of_all_above_columns')}}</p>
                <p> <strong>{{$t('referral_list.name')}}</strong> {{$t('referral_list.name_of_your_referral')}} </p>
                <p> <strong>{{$t('referral_list.account_stage')}}</strong> {{$t('referral_list.meaning_of_various_stages')}}</p>
                <p> <strong>{{$t('referral_list.registered')}}</strong> {{$t('referral_list.registered_link')}}</p>
                <p> <strong>{{$t('referral_list.funded')}}</strong> {{$t('referral_list.referral_deposited')}}</p>
                <p> <strong>{{$t('referral_list.third_point_qualified')}}</strong> {{$t('referral_list.referral_has_deposited')}}</p>
                <p> <strong>{{$t('referral_list.deposits')}}</strong> - {{$t('referral_list.deposits_made_by_referral')}}</p>
                <p> <strong>{{$t('referral_list.volume_requirement')}}</strong> {{$t('referral_list.volume_required_for_reward')}}</p>
                <p> <strong>{{$t('referral_list.traded_volume')}}</strong> {{$t('referral_list.volume_your_referral_traded')}}</p>
                <p> <strong>{{$t('referral_list.qualified')}}</strong> {{$t('referral_list.referral_qualified_for_reward')}}</p>

                <br>
                <p>{{$t('referral_list.referral_ib_programs')}} <a href="#">{{$t('referral_list.here')}}</a>.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
